/** This is a second action bar that appears below extra long journal/lit content */ import React, { useState, useRef, useLayoutEffect } from 'react';
import ActionBar from '..';
import { ActionBarContext, SecondaryActionBarContext } from '../ActionBarContext';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import s from './SecondaryActionBar.scss';
const SecondaryActionBar = ({ children, wrapperClassName, deviation })=>{
    const anchorRef = useRef(null);
    const topBarRef = useRef(null);
    const [showSecondaryActionBar, setShowSecondaryActionBar] = useState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(()=>{
        const content = topBarRef.current;
        const anchor = anchorRef && anchorRef.current;
        if (!content || !anchor || typeof window === 'undefined') {
            return;
        }
        const top = content.getBoundingClientRect().top;
        const bottom = anchor.getBoundingClientRect().top;
        setShowSecondaryActionBar(bottom - top > window.innerHeight);
    });
    return /*#__PURE__*/ React.createElement(SecondaryActionBarContext.Provider, {
        value: {
            setTopActionBarRef: (refNode)=>{
                topBarRef.current = refNode;
            }
        }
    }, children, /*#__PURE__*/ React.createElement("div", {
        ref: anchorRef,
        style: {
            width: 1,
            float: 'left'
        }
    }), showSecondaryActionBar && /*#__PURE__*/ React.createElement("div", {
        className: wrapperClassName
    }, /*#__PURE__*/ React.createElement(ActionBarContext.Provider, {
        value: "secondary"
    }, /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(PanelPopup, {
        deviation: deviation,
        actionBarType: "secondary",
        className: s['large-popover-uplifted']
    }))));
};
SecondaryActionBar.displayName = 'SecondaryActionBar';
export default SecondaryActionBar;

//# sourceMappingURL=SecondaryActionBar.js.map